import React, { Component } from 'react'

export class Footer extends Component {
    render() {
        return (
            <>
                <footer className="footer mt-auto ">
                    <div className="d-flex">
                        <small>Idea Box © Siemens Mobility Portugal 2020</small>
                        <small className="ml-auto">
                            {`v. ${process.env.REACT_APP_VERSION} | By Lisbon Data Science Hub`}
                        </small>
                    </div>
                </footer>
            </>
        )
    }
}

export default Footer
